<template>
  <div>
    <title-header-table class="mt-4">
      <span>Movimientos al {{ currentDate }}</span>
    </title-header-table>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :search="search"
      class="elevation-2 table__desing-general table__desing-border table__movements--scroll mb-5"
      :items-per-page="filteredItems.length"
      :mobile-breakpoint="null"
      :loading="loading"
      loading-text="Cargando... Por favor espere"
      hide-default-footer
    >
      <template #[`header.TIPO`]="{ header }">
        {{ header.text }}
        <v-select
          v-model="showAllDocuments"
          :items="allDocuments"
          label="Todos los Documentos"
          dense
          solo
          hide-details
        />
      </template>

      <template #item="{ item }">
        <customer-briefcase-row-table :invoice="item" />
      </template>

      <template #foot>
        <tfoot>
          <tr>
            <td colspan="9" class="text-right"><b>Subtotales:</b></td>
            <td class="foot-sub-total">
              <b>${{ sumToExpire | formatCurrency }}</b>
            </td>
            <td class="foot-sub-total text-danger">
              <b>${{ sumExpired | formatCurrency }}</b>
            </td>
          </tr>
          <tr>
            <td colspan="13" class="text-right foot-total">
              <b>Saldo total: ${{ sumAmount | formatCurrency }}</b>
            </td>
          </tr>
        </tfoot>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import moment from 'moment';
  import CustomerBriefcaseRowTable from './CustomerBriefcaseRowTable.vue';
  import TitleHeaderTable from '@/components/tables/TitleHeaderTable';
  export default {
    components: { CustomerBriefcaseRowTable, TitleHeaderTable },
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      isCheckedInvoices: Boolean,
    },
    data() {
      return {
        headers: [
          {
            text: '# documento',
            value: 'BELNR',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Tipo de documento',
            value: 'TIPO',
            align: 'center',
            sortable: false,
          },
          { text: 'Descargas', value: 'ver', align: 'center', sortable: false },
          {
            text: 'Orden de Compra',
            value: '',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Fecha de documento',
            value: 'BUDAT',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Fecha de entrega',
            value: '',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Fecha de vencimiento',
            value: 'FVENC',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Días vencido',
            value: 'DMORA',
            align: 'center',
            sortable: false,
          },
          { text: 'Importe', value: 'DMBTR', align: 'center', sortable: false },
          {
            text: 'Saldo sin vencer',
            value: '',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Saldo vencido',
            value: '',
            align: 'center',
            sortable: false,
          },
        ],
        currentDate: moment().format('D [de] MMMM [del] YYYY HH:mm:ss a'),
      };
    },
    computed: {
      filteredItems() {
        return this.items.filter((item) => {
          const documents =
            !this.showAllDocuments || item.TIPO === this.showAllDocuments;
          const invoices = !this.isCheckedInvoices || item.DMORA > 0;

          return documents && invoices;
        });
      },
      allDocuments() {
        const documentos = this.items.map((item) => ({
          text: item.TIPO,
          value: item.TIPO,
        }));
        return [{ text: 'Todos los Documentos', value: '' }, ...documentos];
      },
      sumExpired() {
        return this.filteredItems.reduce((total, item) => {
          return item.DMORA > 0 ? total + parseFloat(item.DMBTR) : total;
        }, 0);
      },
      sumToExpire() {
        return this.filteredItems.reduce((total, item) => {
          return item.DMORA <= 0 ? total + parseFloat(item.DMBTR) : total;
        }, 0);
      },
      sumAmount() {
        return this.filteredItems.reduce((total, item) => {
          if (!item.inserted) {
            let subTotal = 0;
            if (item.DETFAC && item.DETFAC.length > 0) {
              subTotal += item.DETFAC.reduce((totalDetFac, detail) => {
                return totalDetFac + (parseFloat(detail.DMBTR) || 0);
              }, 0);
            }
            return total + subTotal + (parseFloat(item.DMBTR) || 0);
          }
          return total;
        }, 0);
      },
    },
  };
</script>

<style scoped>
  ::v-deep table thead .v-input__slot,
  ::v-deep table thead .v-input__control {
    min-height: auto !important;
    background: transparent linear-gradient(180deg, #a82222 0%, #ff0000 100%) 0%
      0% no-repeat padding-box !important;
    opacity: 1;
  }
  ::v-deep table thead .v-input__slot .v-icon {
    color: #fff !important;
  }
  ::v-deep table .v-input__slot .v-label,
  ::v-deep table .v-input__slot .v-select__selection {
    font-size: 11px !important;
    color: #fff !important;
  }
</style>
